import { render, staticRenderFns } from "./DashboardMessagesCards.vue?vue&type=template&id=2cd5f69d&"
import script from "./DashboardMessagesCards.vue?vue&type=script&lang=js&"
export * from "./DashboardMessagesCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports